<template>
  <fieldset
      class="customer-address-component">
    <!-- User can have an empty location without address -->
    <div
        v-if="locations.length && locations[0].address">
      <h3
          class="info">
        Select shipping address:
      </h3>
      <el-radio-group
          v-model="location"
          class="locations-group"
          @input="selectRadioAddress()">
        <el-radio
            v-for="loc in locations"
            :key="loc.location_id"
            :label="loc"
            :disabled="!isAllowedLocation(loc)"
            style="margin-bottom: 10px">
          <el-tooltip
              v-if="loc.address"
              content="Location not allowed, we cannot ship devices to this country"
              placement="top"
              :disabled="!!isAllowedLocation(loc)">
            <span>
              <b>{{ loc.name }}</b> - {{ loc.address.address1 }}, {{ loc.address.address2 }} {{ loc.address.city }} {{ loc.address.state }} {{ loc.address.country }}
            </span>
          </el-tooltip>
        </el-radio>
      </el-radio-group>
      <p>
        <a
            v-if="!showAddressForm"
            @click="showNewAddressForm()">
          <i class="el-icon-plus"></i> Enter a different address
        </a>
        <a
            v-if="showAddressForm"
            @click="showAddressForm = false">
          <i class="el-icon-s-fold"></i> Hide address input
        </a>
      </p>
      <p>
        <i class="el-icon-phone"></i>
        <i class="el-icon-s-custom"></i>
        Confirm address with customer before proceeding
      </p>
    </div>
    <div v-show="showAddressForm">
      <legend>
        <el-switch
            v-model="googleOn"
            active-text="Google Places" />
      </legend>

      <GooglePlacesAddressForm
          v-show="currentLocation"
          ref="addressForm"
          :autocomplete="googleOn"
          :current-address="currentLocation"
          @update="onUpdate" />
    </div>
  </fieldset>
</template>

<script>
import GooglePlacesAddressForm from "@/components/Shared/AddressForm/GooglePlacesAddressForm";
import { createNamespacedHelpers as h } from "vuex";
import { get } from "lodash";

const { mapGetters: accountGetters } = h("db/account");
const { mapGetters: requestGetters } = h("db/requests");

export default {
  name: "CustomerAddressForm",
  components: {
    GooglePlacesAddressForm,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isValid: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      location: {},
      currentLocation: this.value,
      googleOn: true,
      switching: false,
      countries: [],
      showAddressForm: false,
      plc_action: "",
    };
  },
  computed: {
    ...accountGetters(["customer"]),
    ...requestGetters(["requestInProgress"]),
    locations() {
      return get(this.customer, "locations", []);
    },
  },
  watch: {
    googleOn() {
      this.switching = true;
      setTimeout(() => (this.switching = false), 500);
    },
    location() {
      this.googleOn = false;
      this.setCurrentLocation();
    },
    showAddressForm() {
      this.googleOn = this.showAddressForm;
    },
    customer() {
      this.loadInitialState();
    },
  },
  mounted() {
    setTimeout(
      () =>
        this.$nextTick(() => {
          this.loadInitialState();
        }),
      500
    );
  },
  methods: {
    setCurrentLocation() {
      this.currentLocation = {
        customer_address_1: get(this.location, "address.address1", ""),
        customer_address_2: get(this.location, "address.address2", ""),
        customer_city: get(this.location, "address.city", ""),
        customer_zip: get(this.location, "address.zip_code", ""),
        customer_country: get(this.location, "address.country", ""),
        customer_state: get(this.location, "address.state", ""),
      };
    },
    loadInitialState() {
      this.plc_action = this.requestInProgress.general.type;
      if (this.requestInProgress.general.type == "one_off") {
        this.plc_action = "oneoff";
      }
      this.showAddressForm = false;
      if (
        this.locations.length === 0 ||
        (this.locations.length === 1 && !this.locations[0].address) ||
        !get(this.customer, "id")
      ) {
        this.showAddressForm = true;
      } else if (this.locations.length === 1 && this.locations[0].address) {
        this.location = this.locations[0];
        this.setCurrentLocation();
      } else {
        this.currentLocation = this.value;
      }
    },
    onUpdate(result) {
      this.$emit("input", result.address);
      this.$emit("update:isValid", result.isValid);
      if (this.location && this.location.address && !result.isValid) {
        this.showAddressForm = true;
      }
    },
    resetFields() {
      this.$refs.addressForm.resetFields();
      this.loadInitialState();
    },
    selectRadioAddress() {
      this.showAddressForm = false;
      this.setCurrentLocation();
    },
    showNewAddressForm() {
      this.showAddressForm = true;
      this.location = {};
    },
    isAllowedLocation(loc) {
      let valid = false;
      //Avoid unsupported markets
      if (
        loc &&
        loc.plc_market &&
        loc.plc_market.market_name == "Not supported"
      ) {
        valid = false;
      } else {
        valid = get(
          loc,
          "plc_market.market_details.options.plc.permits." + this.plc_action
        );
      }
      return valid;
    },
  },
};
</script>

<style lang="scss">
.info {
  color: #1998d5;
  font-weight: 300;
  margin: 5px;
}

.el-form-grid {
  margin-bottom: 32px;
}
.el-form-grid .el-form-item {
  margin-bottom: 0;
}

fieldset {
  &.customer-address-component {
    margin-top: 35px;
    margin-bottom: 30px;
    border: 0.5px dashed gray;
    padding: 10px;
  }
  .locations-group {
    .el-radio {
      display: block !important;
    }
    .el-radio__label {
      font-weight: 300 !important;
      font-size: 14px !important;
    }
  }
  legend {
    .el-switch {
      .el-switch__label > span {
        font-size: 14px;
      }

      .el-switch__core {
        width: 35px;
        height: 16px;
        &::after {
          height: 12px;
          width: 12px;
        }
      }
    }
  }
}
</style>
